<ngx-spinner type="ball-clip-rotate"></ngx-spinner>
<ng-container *ngIf="initialized">
  <div *ngIf="page === 'login'">
    <app-hayfever-login></app-hayfever-login>
  </div>

  <div *ngIf="page === 'register'">
    <app-hayfever-register></app-hayfever-register>
  </div>

  <div *ngIf="page === 'forgot-password'">
    <app-hayfever-forgot-password></app-hayfever-forgot-password>
  </div>

  <!-- 送信しましたページ -->
  <div *ngIf="page === 'password-reset-send'">
    <app-hayfever-change-password-sent></app-hayfever-change-password-sent>
  </div>

  <app-hayfever-register-resend
    *ngIf="page === 'register-resend'"
  ></app-hayfever-register-resend>
</ng-container>
